
import { ScrollArea } from "@/components/ui/scroll-area";
import EquipmentLibrary from './EquipmentLibrary';

const Sidebar = () => {
  return (
    <div className="border-r bg-card w-[300px] flex flex-col h-full">
      <div className="flex items-center justify-between p-4 border-b">
        <h2 className="font-semibold">Toestellen</h2>
      </div>
      <ScrollArea className="flex-1 overflow-y-auto">
        <EquipmentLibrary />
      </ScrollArea>
      <div className="p-3 border-t">
        <div className="text-center text-muted-foreground text-xs">
          Made with <span className="text-green-500">💚</span> by{" "}
          <a 
            href="https://beterturnen.nl/turnles-planner" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:underline hover:text-primary transition-colors"
          >
            Beter Turnen
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
